import { useContext } from 'react'
import { enqueueSnackbar } from 'notistack'
import { useNavigate } from 'react-router-dom'

import { Dialog, DialogActions, DialogContent, DialogTitle, Button } from '@mui/material'
import ArchiveOutlinedIcon from '@mui/icons-material/ArchiveOutlined'

import { AppContext } from '/providers/app-context'
import { archiveTemplate } from '/providers/templates-api'

const ArchiveDialog = ({ open, setOpen, template }) => {
  
  const { apiSource, apiKey, refreshTemplates, processing, setProcessing } = useContext(AppContext)
  const navigate = useNavigate()

  if (!template) return null

  const doArchive = async () => {
    close()
    setProcessing(true)
    enqueueSnackbar({ message: 'Archiving template', variant: 'light' })
    await archiveTemplate({ apiSource, apiKey, templateId:template.template_id })
    // TODO handler error
    enqueueSnackbar({ message: 'Template Archived', variant: 'success' })
    setProcessing(false)
    refreshTemplates(template.template_id)
    navigate("/templates")
  }

  const close = () => setOpen(false)

  return (
    <Dialog
      open={open}
      onClose={close}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">
        Archive Template : {template.name}
      </DialogTitle>

      <DialogContent>
        <p className='mb-5'>You will not be able to generate new passes for an archived pass.</p>
        <p className='mb-5'>Archived pass templates will be hidden from view.</p>
        <p className='mb-5'>Pass templates can be unachived at any time.</p>
      </DialogContent>

      <DialogActions>
        <div className="flex flex-row justify-between w-full p-5">
          <Button variant="outlined" onClick={close} disabled={processing}>Cancel</Button>
          <Button variant="contained" onClick={doArchive} autoFocus disabled={processing}><ArchiveOutlinedIcon className="mr-5" />Archive Template</Button>
        </div>
      </DialogActions>
    </Dialog>
  )
}

export default ArchiveDialog